import { createFileRoute } from "@tanstack/react-router";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import {
  IconCash,
  IconTrendingUp,
  IconPercentage,
  IconCalendar,
} from "@tabler/icons-react";

import { AppShell } from "@/components/layout/app-shell";
import { ProtectedRoute } from "@/components/layout/protected-route";

export const Route = createFileRoute("/commission/")({
  component: CommissionPage,
});

function CommissionPage() {
  return (
    <ProtectedRoute>
      <AppShell>
        <CommissionContent />
      </AppShell>
    </ProtectedRoute>
  );
}

function CommissionContent() {
  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-3xl font-bold">Commission & Earnings</h1>
        <p className="text-muted-foreground mt-1">
          Track your commission earnings and payment history
        </p>
      </div>

      {/* Commission Stats */}
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Total Earnings</CardTitle>
            <IconCash className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">৳12,450</div>
            <p className="text-xs text-muted-foreground">
              +12% from last month
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">This Month</CardTitle>
            <IconCalendar className="h-4 w-4 text-blue-500" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-blue-600">৳2,340</div>
            <p className="text-xs text-muted-foreground">
              From 45 transactions
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Commission Rate</CardTitle>
            <IconPercentage className="h-4 w-4 text-green-500" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-green-600">0.5%</div>
            <p className="text-xs text-muted-foreground">
              Your current rate
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Pending</CardTitle>
            <IconTrendingUp className="h-4 w-4 text-orange-500" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-orange-600">৳450</div>
            <p className="text-xs text-muted-foreground">
              Awaiting payout
            </p>
          </CardContent>
        </Card>
      </div>

      {/* Placeholder for commission details */}
      <Card>
        <CardHeader>
          <CardTitle>Commission History</CardTitle>
          <CardDescription>
            Detailed breakdown of your commission earnings and payouts
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="text-center py-8">
            <IconCash className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
            <p className="text-muted-foreground">Commission tracking coming soon</p>
            <p className="text-sm text-muted-foreground mt-2">
              This feature is under development and will be available soon.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}